import styled from 'styled-components'

export const StyledEventStatisticBlockOtherInfo = styled.div`
  align-items: center;
  display: flex;
  gap: 2px;
  min-width: 0;
`
